import CreateDamage from "./CreateDamage";
import DeleteConfirmation from "./DeleteConfirmation";
import EditDamage from "./EditDamage";
import ChooseForm from "./ChooseForm";

const Dialogs  = {
    CreateDamage,
    EditDamage,
    DeleteConfirmation,
    ChooseForm
}

export default Dialogs;